(function(document){
	document.addEventListener('scriptReviews:loaded', () => {
		const main = document.querySelector('#main');
		let eventSend = false;

		const callback = (mutationList) => {
			mutationList.forEach((mutation)=> {
				if (mutation.target.className == 'NETREVIEWS_PRODUCT_STARS' && !eventSend) {
					document.dispatchEvent(new CustomEvent('stars:loaded', {bubbles:true}));
					eventSend = true;
				} 
			});
		};

		const observer = new MutationObserver(callback);
		observer.observe(main, {childList: true, subtree: true});

		document.addEventListener('stars:loaded', () => {
			const allReviews = document.querySelectorAll('.NETREVIEWS_PRODUCT_STARS');
			const review = document.querySelector('.netreviews_review_rate_and_stars');

			allReviews.forEach((element) => {
				if(element.childElementCount == 0) {
					const clone = review.cloneNode(true);
					clone.lastChild.textContent = '0/5 - 0 Opiniões';
					clone.removeChild(clone.children[1]);
					
					element.appendChild(clone);
				}
				const textReview = element.querySelector('.netreviews_reviews_rate');
				element.parentNode.setAttribute('aria-label', textReview.textContent);
			});

			eventSend = false;
		});

	});
})(document);